import HomeView from './view_Home'

export default [
	{
		path: '/',
		name: 'home',
		component: HomeView,
	},
]
